import React from 'react';
import PropTypes from 'prop-types';
import { ThemeProvider } from 'styled-components';
import commonProps from './common/common-props';
import Hero from './contributor-components/hero';
import Main from './contributor-components/main';

export default function Contributor(props) {
  const common = commonProps();
  const { profile } = props;

  return (
    <ThemeProvider theme={common}>
      <Hero {...profile} />
      <Main {...props} />
    </ThemeProvider>
  );
}

Contributor.propTypes = {
  profile: PropTypes.shape({
    id: PropTypes.number.isRequired,
    name: PropTypes.string,
    firstName: PropTypes.string,
    lastName: PropTypes.string,
    slug: PropTypes.string,
    organization: PropTypes.string,
    position: PropTypes.string,
    joinedCurrentRoleAt: PropTypes.string,
    recentCareer: PropTypes.shape({
      organisation: PropTypes.string,
      position: PropTypes.string,
      joinedAt: PropTypes.string,
      leftAt: PropTypes.string,
    }),
    joinedIndustryAt: PropTypes.string,
    accred: PropTypes.string,
    countryName: PropTypes.string,
    cityName: PropTypes.string,
    profilePictureUrl: PropTypes.string,
    headlineGrab: PropTypes.string,
    blurb: PropTypes.string,
    investmentPhilosophy: PropTypes.arrayOf(PropTypes.string),
    linkedinUrl: PropTypes.string,
    twitterUrl: PropTypes.string,
    activePartnership: PropTypes.shape({
      id: PropTypes.number,
    }),
    areasOfExpertise: PropTypes.arrayOf(PropTypes.shape({
      id: PropTypes.number,
      slug: PropTypes.string,
      name: PropTypes.string,
    })),
    canPostWires: PropTypes.bool,
    company: PropTypes.shape({
      name: PropTypes.string,
      logo: PropTypes.string,
      color: PropTypes.string,
    }),
    fund: PropTypes.shape({
      name: PropTypes.string,
      type: PropTypes.string,
      publicUrl: PropTypes.string,
    }),
    activeFeatures: PropTypes.arrayOf(PropTypes.string),
  }).isRequired,
  stats: PropTypes.shape({
    viewsCount: PropTypes.number,
    followersCount: PropTypes.number,
    wiresCount: PropTypes.number,
    since: PropTypes.string,
  }).isRequired,
  isProfileFollowedByCurrentUser: PropTypes.bool.isRequired,
  isOfCurrentUser: PropTypes.bool.isRequired,
  investorTypes: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
    }),
  ).isRequired,
  viewAllWiresLink: PropTypes.string,
};

Contributor.defaultProps = {
  viewAllWiresLink: '',
};
